/* eslint-ignore */
// @ts-nocheck
// @ts-ignore
// export const passwordRegex =
//   /^(?=.*[a-z])(?!.*((012)|(123)|(234)|(345)|(456)|(567)|(678)|(789)))(?!.*((111)|(222)|(333)|(444)|(555)|(666)|(777)|(888)|(999)|(000)))(?!.*((ABC)|(BCD)|(CDE)|(DEF)|(EFG)|(FGH)|(GHI)|(HIJ)|(IJK)|(JKL)|(KLM)|(LMN)|(MNO)|(NOP)|(OPQ)|(PQR)|(QRS)|(RST)|(STU)|(TUV)|(UVW)|(VWX)|(WXY)|(XYZ)))(?!.*((AAA)|(BBB)|(CCC)|(DDD)|(EEE)|(FFF)|(GGG)|(HHH)|(III)|(JJJ)|(KKK)|(LLL)|(MMM)|(NNN)|(OOO)|(PPP)|(QQQ)|(RRR)|(SSS)|(TTT)|(UUU)|(VVV)|(WWW)|(XXX)|(YYY)|(ZZZ)))(?!.*((abc)|(bcd)|(cde)|(def)|(efg)|(fgh)|(ghi)|(hij)|(ijk)|(jkl)|(klm)|(lmn)|(mno)|(nop)|(opq)|(pqr)|(qrs)|(rst)|(stu)|(tuv)|(uvw)|(vwx)|(wxy)|(xyz)))(?!.*((aaa)|(bbb)|(ccc)|(ddd)|(eee)|(fff)|(ggg)|(hhh)|(iii)|(jjj)|(kkk)|(lll)|(mmm)|(nnn)|(ooo)|(ppp)|(qqq)|(rrr)|(sss)|(ttt)|(uuu)|(vvv)|(www)|(yyy)|(zzz)))(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{10,15}$/;

export const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/;
export const fullNameRegex = /^[A-zÀ-ÿ]+(?:\s[A-zÀ-ÿ]+)+/;

export const fullNameWithNumberRegex = /^[A-zÀ-ÿ0-9]+(?:\s[A-zÀ-ÿ0-9]+)+/;

export const nameRegex = /^[A-zÀ-ÿ]+/;

export const cellPhoneNumberRegex = /^[1-9]{2}9[0-9]{8}$/;

export const cellPhoneNumberWithMaskRegex =
  /^\([1-9]{2}\) [9]{1}[0-9]{4}-[0-9]{4}$/;

export const emailRegex = /\S+@\S+\.\S+/;
